import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  let modal_id = '#product-detail-media-modal';
  let modalElement = document.querySelector(modal_id);
  if (modalElement) {
    let modal = new Modal(modalElement, { backdrop: false });

    // Reload iframe src in modal to fix YouTube video thumbnail resolution
    modalElement.addEventListener('shown.bs.modal', event => {
      let iframes = modalElement.querySelectorAll('iframe');
      iframes.forEach(iframe => {
        let src = iframe.getAttribute('src');
        iframe.setAttribute('src', '');
        iframe.setAttribute('src', src);
      });
    });

    document.querySelectorAll('.media-modal-trigger').forEach((trigger) => {
      trigger.addEventListener('click', (evt) => {
        evt.preventDefault();
        let carousel_index = evt.currentTarget.getAttribute('data-wf-index');
        if (window.wf_carousel && window.wf_carousel['pdp-modal-carousel']) {
          window.wf_carousel['pdp-modal-carousel'].slideTo(carousel_index, 0);
        }
        modal.show();
        return false;
      });
    });
  }
});